export enum ChartType {
    BAR = "BAR",
    STACKED_BAR = "STACKED_BAR",
    LINE = "LINE",
}